import { api } from './BaseApi'
import { IPlanMenuDto } from './dto/PlanMenuDto'
import {
  IPlanMenuControlDimensionDto,
  IPlanMenuControlOrderDto,
  IPlanMenuControlOrderLineDto,
  IPlanMenuControlOrdersDto,
  IPlanMenuControlOrdersLinesOpenDto,
  IPlanMenuControlOrdersRequest,
} from './dto/PlanMenuControlDto'
import { createQueryStringSmart } from 'utils/createQueryString'

export const planMenuControlApi = api.injectEndpoints({
  endpoints: (builder) => ({
    getPlanMenuControlOrders: builder.query<
      IPlanMenuControlOrdersDto,
      IPlanMenuControlOrdersRequest
    >({
      query: (params) => ({
        url: `/plan_menu_control_router/${createQueryStringSmart(params)}`,
      }),
      providesTags: ['PlanMenuControl'],
    }),

    getPlanMenuControlOrder: builder.query<
      IPlanMenuControlOrderDto,
      { id: number }
    >({
      query: ({ id }) => ({
        url: `/plan_menu_control_router/${id}/`,
      }),
      providesTags: ['PlanMenuControl'],
    }),
    getPlanMenuControlOrderLine: builder.query<
      IPlanMenuControlOrderLineDto[],
      { id: number } & IPlanMenuControlOrdersRequest
    >({
      query: ({ id, ...params }) => ({
        url: `/plan_menu_control_order_line/order_lines/${id}/`,
        params: !!params ? { ...params } : {},
      }),
      providesTags: ['PlanMenuControl'],
    }),
    getPlanMenuControlOrderLineOnlyRead: builder.query<
      { results: IPlanMenuControlOrderLineDto[] },
      { order: number } & IPlanMenuControlOrdersRequest
    >({
      query: (params) => ({
        url: `/read_only_plan_menu_control_order_line/`,
        params: !!params ? { ...params } : {},
      }),
      providesTags: ['PlanMenuControl'],
    }),
    getPlanMenuControlDimension: builder.query<
      IPlanMenuControlDimensionDto[],
      { id: number } & IPlanMenuControlOrdersRequest
    >({
      query: ({ id, ...params }) => ({
        url: `/plan_menu_dimension_control/order_line_dimensions/${id}/`,
        params: !!params ? params : {},
      }),
      providesTags: ['PlanMenuControl'],
    }),
    getPlanMenuControlDimensionOnlyRead: builder.query<
      { results: IPlanMenuControlDimensionDto[] },
      { order_line: number } & IPlanMenuControlOrdersRequest
    >({
      query: (params) => ({
        url: `/read_only_plan_menu_control_dimension/`,
        params: !!params ? params : {},
      }),
      providesTags: ['PlanMenuControl'],
    }),
    getPlanMenuControlDimensionDetail: builder.query<
      IPlanMenuControlDimensionDto,
      { id: number }
    >({
      query: ({ id }) => ({
        url: `/plan_menu_dimension_control/${id}/`,
      }),
      providesTags: ['PlanMenuControl'],
    }),
    getPlanMenuControlDimensionDetailOnlyRead: builder.query<
      IPlanMenuControlDimensionDto,
      { id: number }
    >({
      query: ({ id }) => ({
        url: `/read_only_plan_menu_control_dimension/${id}/`,
      }),
      providesTags: ['PlanMenuControl'],
    }),
    getAllPlanMenuControlOrdersLine: builder.query<
      IPlanMenuControlOrdersLinesOpenDto,
      IPlanMenuControlOrdersRequest
    >({
      query: (params) => ({
        url: `/plan_menu_control_order_line/order_lines_open/${createQueryStringSmart(
          params,
        )}`,
      }),
      providesTags: ['PlanMenuControl'],
    }),
    getOpenBuffetOrders: builder.query<
      IPlanMenuControlOrdersLinesOpenDto,
      IPlanMenuControlOrdersRequest
    >({
      query: (params) => ({
        url: `/order/get_open_buffet_orders/`,
        params: !!params ? params : {},
      }),
      providesTags: ['PlanMenuControl'],
    }),
    updatePlanMenuOrderComment: builder.mutation<
      IPlanMenuDto,
      { id: number; comment: string }
    >({
      query: ({ id, comment }) => ({
        method: 'PATCH',
        url: `/plan_menu_control_router/${id}/`,
        body: { comment },
      }),
      invalidatesTags: ['PlanMenuControl'],
    }),
    updatePlanMenuDimensionComment: builder.mutation<
      IPlanMenuDto,
      { id: number; comment?: string; dimensionTags?: number[] }
    >({
      query: ({ id, comment, dimensionTags }) => ({
        method: 'PATCH',
        url: `/plan_menu_dimension_control/${id}/`,
        body: { comment, dimensionTags },
      }),
      invalidatesTags: ['PlanMenuControl'],
    }),
  }),
})

export const {
  useGetPlanMenuControlOrdersQuery,
  // useGetPlanMenuControlOrdersOnlyReadQuery,
  useGetPlanMenuControlOrderQuery,
  // useGetPlanMenuControlOrderOnlyReadQuery,
  useGetPlanMenuControlOrderLineQuery,
  useGetPlanMenuControlOrderLineOnlyReadQuery,
  useGetPlanMenuControlDimensionQuery,
  useGetPlanMenuControlDimensionOnlyReadQuery,
  useGetPlanMenuControlDimensionDetailQuery,
  // useGetPlanMenuControlDimensionDetailOnlyReadQuery,
  useGetAllPlanMenuControlOrdersLineQuery,
  useGetOpenBuffetOrdersQuery,
  useUpdatePlanMenuOrderCommentMutation,
  useUpdatePlanMenuDimensionCommentMutation,
} = planMenuControlApi
